export default __webpack_public_path__ + "static/media/blog-01.69ab6d51.jpg";